'use strict';
module.exports = require('./Divider.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/divider/index.js
// module id = 1524
// module chunks = 1